"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(require("./Hidden"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Hidden/index.js
// module id = 375
// module chunks = 226573449209678